import { buildApiUrl } from "../utils/apiConfig";
import type { AthleteHomeActionId } from "../polaris-components/athleteHomeActions";
import { apiClient } from "../utils/apiClient";

export type AthleteOnboardingSteps = Record<AthleteHomeActionId, boolean>;

export type AthleteOnboardingStatus = {
    completed: boolean;
    wizardDismissed: boolean;
    showWizard: boolean;
    steps: AthleteOnboardingSteps;
};

const EMPTY_STEPS: AthleteOnboardingSteps = {
    profile: false,
    ncaa: false,
    "college-list": false,
    "nil-course": false,
    "media-kit": false,
    hub: false,
    calendar: false,
};

export async function fetchAthleteOnboardingStatus(): Promise<AthleteOnboardingStatus | null> {
    try {
        const response = await apiClient(buildApiUrl("/api/athletes/me/onboarding"), {
            headers: { Accept: "application/json" },
            credentials: "include",
        });
        if (!response.ok) {
            return null;
        }
        const data = (await response.json()) as Partial<AthleteOnboardingStatus> & {
            steps?: Partial<AthleteOnboardingSteps>;
        };
        return {
            completed: data.completed === true,
            wizardDismissed: data.wizardDismissed === true,
            showWizard: data.showWizard === true,
            steps: { ...EMPTY_STEPS, ...(data.steps ?? {}) },
        };
    } catch {
        return null;
    }
}

export async function dismissAthleteOnboardingWizard(): Promise<AthleteOnboardingStatus | null> {
    try {
        const response = await apiClient(buildApiUrl("/api/athletes/me/onboarding/wizard/dismiss"), {
            method: "POST",
            credentials: "include",
            headers: { Accept: "application/json" },
        });
        if (!response.ok) {
            return null;
        }
        const data = (await response.json()) as Partial<AthleteOnboardingStatus> & {
            steps?: Partial<AthleteOnboardingSteps>;
        };
        return {
            completed: data.completed === true,
            wizardDismissed: data.wizardDismissed === true,
            showWizard: data.showWizard === true,
            steps: { ...EMPTY_STEPS, ...(data.steps ?? {}) },
        };
    } catch {
        return null;
    }
}

export const ATHLETE_ONBOARDING_UPDATED_EVENT = "athleteOnboardingUpdated";

export function notifyAthleteOnboardingUpdated(): void {
    window.dispatchEvent(new CustomEvent(ATHLETE_ONBOARDING_UPDATED_EVENT));
}
